import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import {NavLink, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Loader from "../components/loader";
import {FormattedMessage} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleUp, faList, faSort} from "@fortawesome/free-solid-svg-icons";

const MarketplaceAdminSidebar = ({marketplace, match}) => {
  const [openXs, setOpenXs] = useState(false);

  const sidebarClasses = classNames({
    "marketplace-admin-sidebar": true,
    "m-open-xs": openXs,
  });

  const marketplaceContent = marketplace? getMarketplaceContent(marketplace): (
    <Loader/>
  );

  return (
    <div className={sidebarClasses}>
      <div className="marketplace-admin-sidebar__top m-b-3">
        <div className="marketplace-admin-sidebar__top-toggle" onClick={() => setOpenXs(!openXs)}>
          {openXs? (<FontAwesomeIcon icon={faAngleUp}/>): (<FontAwesomeIcon icon={faAngleDown}/>)}
        </div>

        {marketplaceContent}
      </div>

      {marketplace? (
        <ul className="list-unstyled">
          <li className="m-b-1">
            🚚 <NavLink exact to={`${match.url}`} className="link">
            <FormattedMessage id={'marketplace.admin.marketplace.links.delivery.days'}/>
          </NavLink>
          </li>
          <li className="m-b-1">
            🧾 <NavLink exact to={`${match.url}/bills`} className="link">
            <FormattedMessage id={'marketplace.admin.marketplace.links.bills'}/>
          </NavLink>
          </li>
          <li className="m-b-1">
            👀 <NavLink to={`${match.url}/view`} className="link">
            <FormattedMessage id={'marketplace.admin.marketplace.links.view'}/>
          </NavLink>
          </li>
          <li className="m-b-1">
            🔧 <NavLink to={`${match.url}/edit`} className="link">
            <FormattedMessage id={'marketplace.admin.marketplace.links.edit'}/>
          </NavLink>
          </li>
          <li className="m-b-1">
            ➕ <NavLink to={`${match.url}/item/create`} className="link">
              <FormattedMessage id={'marketplace.admin.marketplace.links.add.item'}/>
            </NavLink>
          </li>
          <li className="m-b-1">
            <FontAwesomeIcon className="m-r-1" icon={faSort}/> <NavLink to={`${match.url}/marketplaceItems`} className="link">
              <FormattedMessage id={'marketplace.admin.marketplace.links.marketplace.items'}/>
            </NavLink>
          </li>
          <li className="m-b-1">
            <FontAwesomeIcon className="m-r-1" icon={faList}/> <NavLink to={`${match.url}/itemCollections`} className="link">
              <FormattedMessage id={'marketplace.admin.marketplace.links.item.collections'}/>
            </NavLink>
          </li>
          <li className="m-b-1">
            <FontAwesomeIcon className="m-r-1" icon={faList}/> <NavLink to={`${match.url}/combinedOrderItems`} className="link">
              <FormattedMessage id={'marketplace.admin.marketplace.links.combined.order.items'}/>
            </NavLink>
          </li>
          {
            marketplace && marketplace.endConsumerBillsEnabled? (
              <li className="m-b-1">
                💰 <NavLink to={`${match.url}/payoutReports`} className="link">
                <FormattedMessage id={'marketplace.admin.marketplace.links.payout.reports'}/>
              </NavLink>
              </li>
            ): ''
          }
          <li className="m-b-1 d-none">
            🔢 <NavLink to={`${match.url}/item/createBulk`} className="link">
            <FormattedMessage id={'marketplace.admin.marketplace.links.add.items.in.bulk'}/>
          </NavLink>
          </li>
        </ul>
      ): ''}
    </div>
  );
}

function getMarketplaceContent(marketplace) {
  const logoStyles = {
    backgroundImage: marketplace.image? 'url("' + marketplace.image.mainImage + '")' :''
  };

  return (
    <React.Fragment>
      <NavLink to={`/marketplaceAdmin/${marketplace.id}/view`}>
        <div className="marketplace-admin-sidebar__top-logo" style={logoStyles}/>
      </NavLink>

      <NavLink to={`/marketplaceAdmin/${marketplace.id}/view`}>
        <h3 className="m-t-0 marketplace-admin-sidebar__top-name">
          {marketplace.name}
        </h3>
      </NavLink>
    </React.Fragment>
  );
}

MarketplaceAdminSidebar.propTypes = {
  marketplace: PropTypes.object,
};

MarketplaceAdminSidebar.defaultProps = {};

function mapStateToProps(state) {
  return {
    marketplace: state.marketplaces.marketplace,
    currentUser: state.currentUser.user,
  };
}

export default withRouter(connect(mapStateToProps)(MarketplaceAdminSidebar));